<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="width:100%">
            <div style="display: flex">
                <!-- <el-button @click="downFile" type="success" plain size="mini">{{$t('getapi[2762]')}}<i class="el-icon-download el-icon--right"></i>
                </el-button> -->
                <el-upload
                        class="upload-demo"
                        ref="upload"
                        :action="uploadurl"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :on-change="handleChange"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :file-list="fileList"
                        :limit="1"
                        style="margin-left: 8px;width:150px"
                >
                    <el-button type="primary" plain size="mini">{{$t('getapi[7478]')}}<i class="el-icon-upload el-icon--right"></i>
                    </el-button>
                </el-upload>
                <!-- <el-button type="primary" size="mini" @click="removeT">{{$t('getapi[7423]')}}</el-button>
                <el-button type="primary" size="mini" @click="clearT">{{$t('getapi[7424]')}}</el-button> -->
                <el-button type="primary" size="mini" @click="saveData" :loading="loadingSave">{{$t('getapi[6119]')}}</el-button>
                <el-button type="primary" size="mini" @click="doExecute" :loading="loadingExecl" :disabled="!btn.canDoCloseWIP">{{$t('getapi[12357]')}}</el-button>
                <el-button type="primary" size="mini" @click="doLAMExecl" :loading="loadingLam" :disabled="!btn.canDoExecl">{{$t('getapi[12383]')}}</el-button>
                <el-button type="primary" size="mini" @click="doLAMMpsExecl" :loading="loadingLamMps" :disabled="!btn.canDoExecl">{{$t('getapi[12382]')}}</el-button>
               <span style="padding-left:20px;">
                <el-checkbox  size="mini" :disabled="false"  true-label="1" v-model="datatype"
                                false-label="0">{{ $t('getapi[12359]') }}</el-checkbox>
                
                <el-checkbox  size="mini" :disabled="false"  true-label="2" v-model="datatype"
                                false-label="0">{{ $t('getapi[12360]') }}</el-checkbox>
                </span>
            </div>
            
            <div id="xpane-0">
                <vxe-table :data="datasource" size="mini" :loading="loading" header-cell-class-name="headerclass"
                           :height="tableHeight - 60"
                           @row-click="selectrow"
                           :highlight-current-row="true"
                           stripe
                           border
                           resizable
                           ref="singleTable">
                    <vxe-table-column  show-footer-overflow v-for="item in datajson.TbHeader"
                                       :key="item.Headen"
                                       :field="item.Headen"
                                       :title="item.Headcn"
                                       width="120px"
                    ></vxe-table-column>
                </vxe-table>
            </div>
        </div>

        <el-dialog v-dialogDrag :visible.sync="isShowSelectSheet" width="25%" :close-on-click-modal="false">
            <el-table
                    :data="dataSelectSheet"
                    ref="sheetTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    @row-click="changeItem_code"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip prop="name" :label="$t('getapi[6388]')"></el-table-column>
            </el-table>
            <!-- <table style="border-spacing: 5px;" >
                <tr>
                    <td class="alignment-right">
                        {{ $t('getapi[12361]') }}
                        <el-checkbox :disabled="false"  true-label="1" v-model="datatype"
                                        false-label="0">{{ $t('getapi[12359]') }}</el-checkbox>
                        
                        <el-checkbox :disabled="false"  true-label="2" v-model="datatype"
                                        false-label="0">{{ $t('getapi[12360]') }}</el-checkbox>
                    </td>
                </tr>
            </table> -->
            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowSelectSheet = false" >{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="getSalForecastData" :loading="loadingImp" :disabled="selectNameData.length != 1">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: 'forecastimport',
        data() {
            return {
                userData: [], // 用户信息
                DbTbNames: '',
                loading: false, // 主表加载状态
                loadingExecl: false, //计算并导出
                loadingLam:false,
                loadingLamMps:false,
                loadingSave:false,//保存数据
                loadingImp:false,//读取数据
                tableHeight: window.innerHeight - 100, // 主表高度
                dataDetail:{
                    cboyear: '',
                    cbomonth: '',
                    sum: ''
                },
                yearList: [],
                uploadurl: '',
                datajson: [],
                datasource:[],
                returnArray:[],
                returnURL:'',
                excelURL:'',
                fileList: [],
                isShowSelectSheet: false, // 是否显示选择sheet弹窗
                dataSelectSheet: [], //
                selectNameData: [], // 选择的sheet
                selectIndex: '', //选中行下标
                btn:{
                    canDoCloseWIP: false,
                    canDoExecl:false
                },
                datatype:0,
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Sal/Forecast/SalForecastImportUpFile?token=' + token;
        },
        watch: {
            'datajson.Lists': function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.dataDetail.cboyear = new Date().getFullYear()
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12352]"),this.$t("getapi[14]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview"+file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    that.returnURL = res.DataContent.URL;
                    let arr = res.DataContent.SheetList
                    if(arr.length > 0){
                        that.dataSelectSheet = []
                        for(let i=0;i<arr.length;i++){
                            that.dataSelectSheet = [...that.dataSelectSheet,{
                                name: arr[i]
                            }]
                        }
                        that.isShowSelectSheet = true
                    }
                }
                that.fileList=[];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
                that.loading = false;
            },
            getSalForecastData(){
                let that = this
                that.loadingImp = true;
                let parm = {
                    filepath: that.returnURL,
                    sheetname: that.selectNameData[0],
                    datatype:that.datatype,
                }
                that.$http.urlpost('/Sal/Forecast/GetSalForecastData', parm, function (res) {
                    if (res.Success == 1) {                        
                        that.datajson = res.DataContent
                        if(that.datatype==1){
                            that.datasource=that.datajson.Lists
                        }
                        if(that.datatype==2){
                            that.datasource=that.datajson.GLists
                        }
                        that.isShowSelectSheet = false
                        that.btn.canDoCloseWIP = false
                    }
                    that.loadingImp = false;
                });
            },
            changeItem_code(row) {
                let that = this
                that.$refs.sheetTable.toggleRowSelection(row);
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this
                console.log(val)
                that.selectNameData = []
                for(let i = 0;i<val.length;i++){
                    that.selectNameData.push(val[i].name)
                }
            },
            // 保存数据
            saveData(){
                let that = this
                that.loadingSave = true;
                let parm = {
                    // cboyear: that.dataDetail.cboyear,
                    // cbomonth: that.dataDetail.cbomonth,
                    URL: that.datajson.URL,
                    Lists: that.datajson.Lists,
                    WeekLists:that.datajson.WeekLists,
                    LangType:that.$processdata.getLang(),
                    GLists:that.datajson.GLists,
                    datatype:that.datatype,
                }
                that.$http.urlpost('/Sal/Forecast/SaveSalForecastData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.btn.canDoCloseWIP = true
                    } else if(res.Success == 2){
                        that.$message.warning(that.$processdata.explainCallbackMsg(res.Msg))
                        that.datajson = res.DataContent
                    }

                    that.loadingSave = false;
                });
            },
            //LAM寄售模板
            LAMConTemplate(){
                let that = this
                that.loadingExecl=true;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    datatype:that.datatype,
                }
                that.$http.urlpost('/Sal/Forecast/SalForecastMPSExecute', parm, function (res) {
                    that.loadingExecl=false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        // that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        // that.dataDetail.sum = res.UniqueNum
                    }
                });
            },
            // 执行标定
            doExecute(){
                let that = this
                that.loadingExecl=true;
                that.btn.canDoExecl=false;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    datatype:that.datatype,
                }
                that.$http.urlpost('/Sal/Forecast/SalForecastMPSExecute', parm, function (res) {
                    that.loadingExecl=false;
                    if (res.Success == 1) {
                        that.btn.canDoExecl=true;
                        // let hrefurl = Common.Url + res.DataContent.URL;
                        //     window.open(hrefurl);
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        // that.dataDetail.sum = res.UniqueNum
                    }
                });
            },
            doLAMExecl(){
                let that = this
                that.loadingLam=true;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    datatype:1,
                }
                that.$http.urlpost('/Sal/Forecast/SalForecastMPSExportToExecl', parm, function (res) {
                    that.loadingLam=false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        // that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        // that.dataDetail.sum = res.UniqueNum
                    }
                });
            },
            doLAMMpsExecl(){
                let that = this
                that.loadingLamMps=true;
                let parm = {
                    LangType:that.$processdata.getLang(),
                    datatype:2,
                }
                that.$http.urlpost('/Sal/Forecast/SalForecastMPSExportToExecl', parm, function (res) {
                    that.loadingLamMps=false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        // that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        // that.dataDetail.sum = res.UniqueNum
                    }
                });
            },
            selectrow(row){
                let that = this;
                that.selectIndex = row.index;
            },
            removeT(){
                let that = this
                that.datajson.Lists.splice(that.selectIndex,1)
            },
            clearT(){
                let that = this
                that.datajson.Lists = []
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
